module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop.e7fe03c1.jpg";